export enum ListScreenTestIds {
  SCROLL_CONTAINER = 'list-screen-scroll-container',
}
